var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{class:_vm.computedClass},[_vm._t("default",null,{"context":_vm.model.$item})],2)}
var staticRenderFns = []

export { render, staticRenderFns }